"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authLink = exports.addErrorHandler = exports.addAppHeaders = void 0;
exports.createLink = createLink;
exports.fetcher = void 0;
exports.linkConfigBuilder = linkConfigBuilder;
var _client = require("@apollo/client");
var _context = require("@apollo/client/link/context");
var _error = require("@apollo/client/link/error");
var _apolloLinkTimeout = _interopRequireDefault(require("apollo-link-timeout"));
var _getAppVersion = _interopRequireDefault(require("./getAppVersion"));
var _getSessionId = _interopRequireDefault(require("./getSessionId"));
var _logger = _interopRequireDefault(require("./logger"));
var _timeouts = require("../constants/timeouts");
const version = (0, _getAppVersion.default)();
const sessionGuid = (0, _getSessionId.default)();

// This file includes the set up of the apollo link.
// This uses an http link to attempt to retrieve the content first,
// Then a retry - this is set up to handle 401 authentication
// errors by using the OIDC client silent refresh  to obtain a new
// access cookie before retrying, and finally an error handler
// which will force the application into a logged out state if the
// 401 errors persist.

// log rocket compatibility //https://docs.logrocket.com/docs/troubleshooting-sessions#apollo-client
const fetcher = function () {
  return window.fetch(...arguments);
};
exports.fetcher = fetcher;
function linkConfigBuilder(_, context) {
  return {
    ...context,
    credentials: 'include'
  };
}
const authLink = exports.authLink = (0, _context.setContext)(linkConfigBuilder);
const addErrorHandler = onAuthIssue => {
  const errorHandler = error => {
    if (error.networkError) {
      _logger.default.warn("gql call failed ".concat(error.operation.operationName), error);
      /* istanbul ignore else */
      if (onAuthIssue) onAuthIssue(error);
    }
  };

  // @ts-ignore
  return (0, _error.onError)(errorHandler);
};
exports.addErrorHandler = addErrorHandler;
const addAppHeaders = () => (0, _context.setContext)((_, _ref) => {
  let {
    headers
  } = _ref;
  return {
    headers: {
      ...headers,
      CorrelationId: sessionGuid,
      Version: "web-".concat(version)
    }
  };
});

// default timeout
exports.addAppHeaders = addAppHeaders;
const timeoutLink = new _apolloLinkTimeout.default(_timeouts.timeouts.DEFAULT_REQUEST_TIMEOUT);
function createLink(_ref2) {
  let {
    graphQLUrl,
    onAuthIssue
  } = _ref2;
  return _client.ApolloLink.from([addErrorHandler(onAuthIssue), addAppHeaders(), timeoutLink, authLink, (0, _client.createHttpLink)({
    uri: graphQLUrl,
    fetch: fetcher
  })]);
}